import React, { createContext, useContext } from "react";

export type WidgetCanvasContextType = {
    activeWidgetZIndex: number;
    setActiveWidgetZIndex: (zIdx: number) => void;
};

export const WidgetCanvasContext: React.Context<WidgetCanvasContextType> = createContext<WidgetCanvasContextType>({
    activeWidgetZIndex: 0,
    setActiveWidgetZIndex: () => {},
});

export const useWidgetCanvasContext = () => useContext(WidgetCanvasContext);

export default WidgetCanvasContext;
